// import React from 'react';

import Image from './Image';

import './styles/style.scss';

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/index.js